import axios from 'axios'
import moment from 'moment-timezone'

const state = {
    avalabilities: [],
    timeZones: [],
    userTimezone: null,
}

const getters = {
    avalabilities: state => {
        return state.avalabilities
    },
    userTimezone: state => state.userTimezone,
}

const mutations = {
    setAvailabilities (state, avalabilities) {
        state.avalabilities = avalabilities
    },
}

const actions = {
    async getAvailabilities ({ commit }, { assignmentId, zone }) {
        const response = await axios.get(
            `/admin/calendar/client-availabilities/${assignmentId}`)
        const arr = [...response.data.availabilities]
        const newArr = arr.map(function (x) {
            const start = moment.utc(x.start).tz(zone).format('YYYY-MM-DD HH:mm')
            const end = moment.utc(x.end).tz(zone).format('YYYY-MM-DD HH:mm')

            return {
                ...x,
                start: start,
                end: end,
                name: 'Available: Client',
                eventType: { name: 'client' },
                color: { name: 'pink' }
            }
        })

        commit('setAvailabilities', newArr)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
